<template>
  <div>
      <nav>
          <ul>
            <li class=""><a href="javascript:void(0)" v-on:click="go('index')"><img src="../../asset/svg/bookmark/index.svg" alt="回首頁"></a>
            
            </li>
            <li class="aboutbtn"><a href="javascript:void(0)" v-on:click="go('about')"> <img src="../../asset/svg/bookmark/about.svg" alt="關於多寶"></a>
            </li>
            <li class="artistbtn"><a href="javascript:void(0)" v-on:click="go('artist')"><img src="../../asset/svg/bookmark/artist.svg" alt="多寶創作人"></a>
            </li>
            <li class="startbtn"><a href="javascript:void(0)" v-on:click="go('start')"><img src="../../asset/svg/bookmark/start.svg" alt="故事緣起"></a>
            </li>
            <li class="supportbtn"><a href="javascript:void(0)" v-on:click="go('support')"><img src="../../asset/svg/bookmark/support.svg" alt="支持多寶"></a>
            </li>
            <li class="productbtn"><a href="javascript:void(0)" v-on:click="go('product')"><img src="../../asset/svg/bookmark/product.svg" alt="多寶創作商品"></a>
            </li>
            <li class="contactbtn"><a href="javascript:void(0)" v-on:click="go('contact')"><img src="../../asset/svg/bookmark/contact.svg" alt="聯絡多寶"></a>
            </li>
          </ul>
        </nav>
      <header>
          <!-- fb&blog-->
          <ul class="relatelink" v-show="nav">
            <li><a href="javascript:void(0)" class="fbicon" onclick="trackWaitJump('btn_fb','https://www.facebook.com/taiwancurio/')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 16.8"><title>fbicon</title><g><path d="M2.7,13.8c0-1.5,0-3.1,0-4.6C2.7,9,2.6,9,2.4,9C1.7,9,1,9,0.2,9C0.1,9,0,8.9,0,8.7c0-0.9,0-1.8,0-2.8c0-0.2,0.1-0.3,0.3-0.2c0.7,0,1.4,0,2.2,0c0.2,0,0.3,0,0.3-0.3c0-0.5,0-1.1,0-1.6c0-1.5,1-2.9,2.4-3.5C5.6,0.1,6.1,0,6.7,0h2.7c0.2,0,0.3,0.1,0.5,0.1C10.1,0,10,0.1,10,0.2c0,1,0,1.9,0,2.9c0,0.1-0.1,0.2-0.2,0.2H8.3C7.6,3.4,7,3.9,7,4.6c0,0.3,0,0.6,0,0.9S7,5.7,7.2,5.7h2.5c0.2,0,0.2,0,0.2,0.2c0,0.9,0,1.9,0,2.8C10,8.9,9.9,9,9.8,9H7.2C7.1,9,7,9,7,9.2c-0.1,1.2,0,2.5,0,3.7c0,1.9,0,1.8,0,3.7c0,0.2,0,0.3-0.3,0.3H3.1c-0.3,0-0.4-0.1-0.4-0.4C2.7,14.9,2.7,15.3,2.7,13.8z" /></g></svg></a></li>

            <li><a href="javascript:void(0)" class="blogicon" onclick="trackWaitJump('btn_blog','https://taiwancurio.wordpress.com/')"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15.1"><title>blogicon</title><g><path d="M0,7.5c0-0.9,0-1.8,0-2.7C0,2.2,2.2,0,4.9,0c0,0,0,0,0,0h2.5c2.3,0,4.2,1.6,4.7,3.8c0.1,0.4,0.1,0.7,0.1,1.1c0,0.5,0.4,1,1,1c0,0,0,0,0,0H14c0.5,0,0.9,0.4,1,0.8c0,0,0,0.1,0,0.1c0,1.1,0,2.3,0,3.4c0,2.1-1.4,4-3.4,4.7c-0.5,0.1-0.9,0.2-1.4,0.2c-1.8,0-3.6,0-5.3,0c-1.4,0-2.7-0.6-3.6-1.6C0.4,12.6,0,11.4,0,10.2C0,9.3,0,8.4,0,7.5z M7.5,9.4H4.8H4.6c-0.5,0-0.8,0.5-0.8,1c0,0.5,0.5,0.8,1,0.8h5.7c0.5,0,0.8-0.4,0.9-0.8c0-0.3-0.2-0.6-0.5-0.8c-0.2-0.1-0.3-0.2-0.5-0.2L7.5,9.4zM6.1,4H4.7C4.2,4,3.8,4.5,3.9,5c0.1,0.5,0.4,0.8,0.9,0.8h2.8h0.2c0.5-0.1,0.8-0.6,0.7-1.1c0-0.2-0.1-0.4-0.3-0.5C8,4.1,7.7,4,7.5,4L6.1,4z" /></g></svg></a></li>
          </ul>
          <!-- bur-->
          <div class="bur" v-on:click="nav_ctrl()" v-show="nav"><span></span><span></span><span></span></div><a href="javascript:void(0)" class="logo" > <img src="../../asset/svg/logo.svg" alt="logo"></a>
        </header>
  </div> 
</template>

<script>
    export default {
        props: ['nav'],
        methods:{
          go:function(where){
            var $body = (window.opera) ? (document.compatMode == "CSS1Compat" ? $('html') : $('body')) : $('html,body');
            // $body.animate({scrollTop:$('section.'+where).offset().top },1000,'easeInExpo');
            $body.animate({scrollTop:$('section.'+where).offset().top },1000,'easeInQuart');
            gaclick('menu_btn_'+where);
            this.nav_ctrl();
          },
          nav_ctrl:function() {
            $('.bur').toggleClass('activenav');
            $('nav').toggleClass('open');
            gaclick('btn_menu');
          }
      }
    }
</script>


// WEBPACK FOOTER //
// Nav.vue?4227ba16